import { useImmer } from "use-immer";
import { useEffect, useRef, useState } from "react";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Note from "../Note";
import WeightConfig from "./WeightConfig";
import TresholdConfig from "./TresholdConfig";
import DirectPurchaseRuleSkipConfig from "./DirectPurchaseRuleSkipConfig";
import AutoAllowRuleConfig from "./AutoAllowRuleConfig";
import CardAgeRuleConfig from "./CardAgeRuleConfig";
import CardLockAutoAllowRuleConfig from "./CardLockAutoAllowRuleConfig";
import CountryRuleConfig from "./CountryRuleConfig";
import CustomerCountryHistoryRuleConfig from "./CustomerCountryHistoryRuleConfig";
import CustomerFacilityHistoryRuleConfig from "./CustomerFacilityHistoryRuleConfig";
import CustomerHistoryRuleConfig from "./CustomerHistoryRuleConfig";
import CustomerOriginRuleConfig from "./CustomerOriginRuleConfig";
import DaytimeRuleConfig from "./DaytimeRuleConfig";
import FacilityRuleConfig from "./FacilityRuleConfig";
import HotspotRuleConfig from "./HotspotRuleConfig";
import OdometerHistoryRuleConfig from "./OdometerHistoryRuleConfig";
import OdometerIncrementHistoryRuleConfig from "./OdometerIncrementHistoryRuleConfig";
import OdometerLengthHistoryRuleConfig from "./OdometerLengthHistoryRuleConfig";
import OdometerRuleConfig from "./OdometerRuleConfig";
import RecentHotspotRuleConfig from "./RecentHotspotRuleConfig";
import ImmediateHotspotRuleConfig from "./ImmediateHotspotRuleConfig";
import RejectHistoryRuleConfig from "./RejectHistoryRuleConfig";
import SimilarOdometerRuleConfig from "./SimilarOdometerRuleConfig";
import SuddenHotspotVisitRuleConfig from "./SuddenHotspotVisitRuleConfig";
import SuspiciousPassageRuleConfig from "./SuspiciousPassageRuleConfig";
import VelocityRuleConfig from "./VelocityRuleConfig";
import VolumeHistoryRuleConfig from "./VolumeHistoryRuleConfig";
import VolumeRuleConfig from "./VolumeRuleConfig";
import AuthRejectConfig from "./AuthRejectRuleConfig";
import SuddenHotspotRejectRuleConfig from "./SuddenHotspotRejectRuleConfig";
import CompromisedPanRuleConfig from "./CompromisedPanRuleConfig";
import HotspotQuotientRuleConfig from "./HotspotQuotientRuleConfig";
import TrialTransactionRuleConfig from "./TrialTransactionRuleConfig";
import FuelGuardAutoAllowRuleConfig from "./FuelGuardAutoAllowRuleConfig";
import VaryingOdometerRuleConfig from "./VaryingOdometerRuleConfig";
import OdometerOutwornIncrementRuleConfig from "./OdometerOutwornIncrementRuleConfig";
import InsufficientPinEffortRuleConfig from "./InsufficientPinEffortRuleConfig";
import CustomerHistoryPatternRuleConfig from "./CustomerHistoryPatternRuleConfig";

const Component = ({ config, generalConfig, onConfigChange, expandAll, onExpandAllChange }) => {
  const [data, updateData] = useImmer(config);
  const [generalConfigData, updateGeneralConfigData] = useImmer(generalConfig);
  const containerRef = useRef(null);
  const skipEffectRef = useRef(false);
  const stateLoadedRef = useRef(false);
  const [weightsInfoOpen, setWeightsInfoOpen] = useState(false);
  const [thresholdInfoOpen, setThresholdInfoOpen] = useState(false);
  const [autoAllowRuleInfoOpen, setAutoAllowRuleInfoOpen] = useState(false);
  const [cardAgeRuleInfoOpen, setCardAgeRuleInfoOpen] = useState(false);
  const [cardLockAutoAllowRuleInfoOpen, setCardLockAutoAllowRuleInfoOpen] = useState(false);
  const [countryRuleInfoOpen, setCountryRuleInfoOpen] = useState(false);
  const [compromisedPanRuleInfoOpen, setCompromisedPanRuleInfoOpen] = useState(false);
  const [customerCountryHistoryRuleInfoOpen, setCustomerCountryHistoryRuleInfoOpen] = useState(false);
  const [customerFacilityHistoryRuleInfoOpen, setCustomerFacilityHistoryRuleInfoOpen] = useState(false);
  const [customerHistoryRuleInfoOpen, setCustomerHistoryRuleInfoOpen] = useState(false);
  const [customerOriginRuleInfoOpen, setCustomerOriginRuleInfoOpen] = useState(false);
  const [daytimeRuleInfoOpen, setDaytimeRuleInfoOpen] = useState(false);
  const [facilityRuleInfoOpen, setFacilityRuleInfoOpen] = useState(false);
  const [fuelGuardAutoAllowRuleInfoOpen, setFuelGuardAutoAllowRuleInfoOpen] = useState(false);
  const [hotspotRuleInfoOpen, setHotspotRuleInfoOpen] = useState(false);
  const [hotspotQuotientRuleInfoOpen, setHotspotQuotientRuleInfoOpen] = useState(false);
  const [odometerRuleInfoOpen, setOdometerRuleInfoOpen] = useState(false);
  const [odometerHistoryRuleInfoOpen, setOdometerHistoryRuleInfoOpen] = useState(false);
  const [odometerIncrementHistoryRuleInfoOpen, setOdometerIncrementHistoryRuleInfoOpen] = useState(false);
  const [odometerLengthHistoryRuleInfoOpen, setOdometerLengthHistoryRuleInfoOpen] = useState(false);
  const [recentHotspotRuleInfoOpen, setRecentHotspotRuleInfoOpen] = useState(false);
  const [rejectHistoryRuleInfoOpen, setRejectHistoryRuleInfoOpen] = useState(false);
  const [suddenHotspotRejectRuleInfoOpen, setSuddenHotspotRejectRuleInfoOpen] = useState(false);
  const [suddenHotspotVisitRuleInfoOpen, setSuddenHotspotVisitRuleInfoOpen] = useState(false);
  const [suspiciousPassageRuleInfoOpen, setSuspiciousPassageRuleInfoOpen] = useState(false);
  const [trialTransactionRuleInfoOpen, setTrialTransactionRuleInfoOpen] = useState(false);
  const [varyingOdometerRuleInfoOpen, setVaryingOdometerRuleInfoOpen] = useState(false);
  const [velocityRuleInfoOpen, setVelocityRuleInfoOpen] = useState(false);
  const [volumeRuleInfoOpen, setVolumeRuleInfoOpen] = useState(false);
  const [volumeHistoryRuleInfoOpen, setVolumeHistoryRuleInfoOpen] = useState(false);
  const [insufficientPinEffortRuleInfoOpen, setInsufficientPinEffortRuleInfoOpen] = useState(false);
  const [odometerOutwornIncrementRuleInfoOpen, setOdometerOutwornIncrementRuleInfoOpen] = useState(false);
  const [authRejectRulesInfoOpen, setAuthRejectRulesInfoOpen] = useState(false);
  const [similarOdometerRuleInfoOpen, setSimilarOdometerRuleInfoOpen] = useState(false);
  const [customerHistoryPatternRuleInfoOpen, setCustomerHistoryPatternRuleInfoOpen] = useState(false);
  const [immediateHotspotRuleInfoOpen, setImmediateHotspotRuleInfoOpen] = useState(false);

  const handleInfoIconClick = (detailsId, isOpen, setOpen) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    const detailsElement = document.getElementById(detailsId);
    if (!detailsElement.open) {
      detailsElement.open = true;
      setOpen(true);
    } else {
      setOpen(!isOpen);
    }
  };

  useEffect(() => {
    onConfigChange(data);
  }, [data]);

  useEffect(() => {
    updateData(config);
    updateGeneralConfigData(generalConfig);
  }, [config]);

  useEffect(() => {
    if (skipEffectRef.current) {
      skipEffectRef.current = false;
      return;
    }
    if (containerRef.current) {
      const details = containerRef.current.querySelectorAll('details.config-section');
      details.forEach(detail => {
        detail.open = expandAll;
      });
      // Save state to sessionStorage after setting all states
      setTimeout(() => {
        const openStates = {};
        details.forEach((detail) => {
          const sectionId = detail.getAttribute('data-section-id');
          if (sectionId) {
            openStates[sectionId] = detail.open;
          }
        });
        sessionStorage.setItem('posConfigDetailsState', JSON.stringify(openStates));
      }, 150);
    }
  }, [expandAll]);

  // Load state from sessionStorage on mount only
  useEffect(() => {
    const timer = setTimeout(() => {
      if (containerRef.current && !stateLoadedRef.current) {
        const savedState = sessionStorage.getItem('posConfigDetailsState');
        if (savedState) {
          try {
            const openStates = JSON.parse(savedState);
            const details = containerRef.current.querySelectorAll('details.config-section');
            details.forEach((detail) => {
              const sectionId = detail.getAttribute('data-section-id');
              if (sectionId && openStates[sectionId] !== undefined) {
                detail.open = openStates[sectionId];
              }
            });
            stateLoadedRef.current = true;
          } catch (e) {
            console.error('Failed to restore details state:', e);
          }
        } else {
          stateLoadedRef.current = true;
        }
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!containerRef.current) return;

    const handleToggle = () => {
      const details = containerRef.current.querySelectorAll('details.config-section');

      // Save current state to sessionStorage
      const openStates = {};
      details.forEach((detail) => {
        const sectionId = detail.getAttribute('data-section-id');
        if (sectionId) {
          openStates[sectionId] = detail.open;
        }
      });
      sessionStorage.setItem('posConfigDetailsState', JSON.stringify(openStates));

      // Check if all are open and update expandAll if needed
      if (expandAll) {
        const allOpen = Array.from(details).every(detail => detail.open);
        if (!allOpen && onExpandAllChange) {
          skipEffectRef.current = true;
          onExpandAllChange(false);
        }
      }
    };

    const details = containerRef.current.querySelectorAll('details.config-section');
    details.forEach(detail => {
      detail.addEventListener('toggle', handleToggle);
    });

    return () => {
      details.forEach(detail => {
        detail.removeEventListener('toggle', handleToggle);
      });
    };
  }, [expandAll, onExpandAllChange]);

  return (
    <div ref={containerRef}>
      <details
        className="config-section"
        data-section-id="weights"
        id="weights-details"
      >
        <summary>
          <h3>
            Weights{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.weight"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "weights-details",
                  weightsInfoOpen,
                  setWeightsInfoOpen,
                )}
                title={weightsInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {weightsInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Defines how risk scores are assigned</strong>, either manually or
              automatically via "Auto Update." Users should generally avoid
              modifying automatically updated scores.
            </p>
          </div>
        )}

        <WeightConfig
          configId={data.id}
          weightConfig={data.riskEvaluation.weightConfig}
          weightManualConfig={data.riskEvaluation.weightManualConfig || {}}
          ruleSuppressGeneralConfig={
            generalConfigData.generalConfig.ruleSuppressConfig
          }
          onChange={({ weightConfig, weightManualConfig }) =>
            updateData((d) => {
              d.riskEvaluation.weightConfig = weightConfig;
              d.riskEvaluation.weightManualConfig = weightManualConfig || {};
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="threshold"
        id="threshold-details"
      >
        <summary>
          <h3>
            Treshold{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.treshold"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "threshold-details",
                  thresholdInfoOpen,
                  setThresholdInfoOpen,
                )}
                title={thresholdInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {thresholdInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Defines what score has to be reached</strong> for Pablo to
              take action. Users should generally avoid modifying automatically
              updated thresholds.
            </p>
          </div>
        )}

        <TresholdConfig
          configId={data.id}
          tresholdConfig={data.riskEvaluation.tresholdConfig}
          manualConfig={data.riskEvaluation.tresholdManualConfig || {}}
          onChange={({ tresholdConfig, manualConfig }) =>
            updateData((d) => {
              d.riskEvaluation.tresholdConfig = tresholdConfig;
              d.riskEvaluation.tresholdManualConfig = manualConfig || {};
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="directPurchaseThreshold"
        id="directPurchaseThreshold-details"
      >
        <summary>
          <h3>Direct Purchase Treshold</h3>
        </summary>

        <TresholdConfig
          configId={data.id}
          tresholdConfig={data.riskEvaluation.directPurchaseTresholdConfig}
          manualConfig={data.riskEvaluation.directPurchaseTresholdManualConfig || {}}
          onChange={({ tresholdConfig, manualConfig }) =>
            updateData((d) => {
              d.riskEvaluation.directPurchaseTresholdConfig = tresholdConfig;
              d.riskEvaluation.directPurchaseTresholdManualConfig =
                manualConfig || {};
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="directPurchaseRuleSkip"
        id="directPurchaseRuleSkip-details"
      >
        <summary>
          <h3>Direct Purchase Rule Skip</h3>
        </summary>

        <DirectPurchaseRuleSkipConfig
          config={data.riskEvaluation.directPurchaseRuleSkipConfig}
          weightConfig={data.riskEvaluation.weightConfig}
          onChange={(directPurchaseRuleSkipConfig) =>
            updateData((d) => {
              d.riskEvaluation.directPurchaseRuleSkipConfig =
                directPurchaseRuleSkipConfig;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="autoAllowRule"
        id="autoAllowRule-details"
      >
        <summary>
          <h3>
            Auto allow rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.autoAllowRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "autoAllowRule-details",
                  autoAllowRuleInfoOpen,
                  setAutoAllowRuleInfoOpen,
                )}
                title={autoAllowRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {autoAllowRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Reduces the risk score</strong> when a high number of
              consecutive failed attempts is detected (e.g., 7 in 60 mins). This
              rule helps legitimate users who persist after declines, as
              fraudsters rarely retry more than 2-3 times.
            </p>
          </div>
        )}

        <AutoAllowRuleConfig
          config={data.riskEvaluation.autoAllowRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.autoAllowRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="cardAgeRule"
        id="cardAgeRule-details"
      >
        <summary>
          <h3>
            Card age rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.cardAgeRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "cardAgeRule-details",
                  cardAgeRuleInfoOpen,
                  setCardAgeRuleInfoOpen,
                )}
                title={cardAgeRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {cardAgeRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score based on card age</strong>, as
              newer cards statistically have a higher probability of fraud. The
              specific score impact can be configured in the settings.
            </p>
          </div>
        )}

        <CardAgeRuleConfig
          config={data.riskEvaluation.cardAgeRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.cardAgeRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="cardLockAutoAllowRule"
        id="cardLockAutoAllowRule-details"
      >
        <summary>
          <h3>
            Card lock auto allow rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.cardLockAutoAllowRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "cardLockAutoAllowRule-details",
                  cardLockAutoAllowRuleInfoOpen,
                  setCardLockAutoAllowRuleInfoOpen,
                )}
                title={
                  cardLockAutoAllowRuleInfoOpen ? "Hide info" : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {cardLockAutoAllowRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Reduces the risk score</strong> when the transaction's
              status is explicitly set to "UNLOCKED." Since the card was
              actively unlocked for this specific transaction, the probability
              of fraud is considered low.
            </p>
          </div>
        )}

        <CardLockAutoAllowRuleConfig
          config={data.riskEvaluation.cardLockAutoAllowRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.cardLockAutoAllowRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="compromisedPanRule"
        id="compromisedPanRule-details"
      >
        <summary>
          <h3>
            Compromised pan rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.compromisedPanRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "compromisedPanRule-details",
                  compromisedPanRuleInfoOpen,
                  setCompromisedPanRuleInfoOpen,
                )}
                title={compromisedPanRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {compromisedPanRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> if a "Compromised PAN"
              (a card with confirmed past fraud) was recently rejected at the
              current merchant. This activity indicates that a fraudster may be
              testing stolen cards at this location, flagging the current
              transaction as higher risk.
            </p>
          </div>
        )}

        <CompromisedPanRuleConfig
          config={data.riskEvaluation.compromisedPanRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.compromisedPanRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="countryRule"
        id="countryRule-details"
      >
        <summary>
          <h3>
            Country rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.countryRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "countryRule-details",
                  countryRuleInfoOpen,
                  setCountryRuleInfoOpen,
                )}
                title={countryRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {countryRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>
                Increases the risk score based on the transaction country
              </strong>
              , as fraud probability varies by location. You can configure
              specific risk scores for different countries in the settings.
            </p>
          </div>
        )}

        <CountryRuleConfig
          config={data.riskEvaluation.countryRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.countryRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="customerCountryHistoryRule"
        id="customerCountryHistoryRule-details"
      >
        <summary>
          <h3>
            Customer country history rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.customerCountryHistoryRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "customerCountryHistoryRule-details",
                  customerCountryHistoryRuleInfoOpen,
                  setCustomerCountryHistoryRuleInfoOpen,
                )}
                title={
                  customerCountryHistoryRuleInfoOpen ? "Hide info" : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {customerCountryHistoryRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when a customer
              transacts in a "monitored" country for the first time. This rule
              flags unusual presence in specific high-risk locations but ignores
              countries not configured for monitoring.
            </p>
          </div>
        )}

        <CustomerCountryHistoryRuleConfig
          config={data.riskEvaluation.customerCountryHistoryRuleConfig}
          customerHistoryConfig={data.riskEvaluation.customerHistoryRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.customerCountryHistoryRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="customerFacilityHistoryRule"
        id="customerFacilityHistoryRule-details"
      >
        <summary>
          <h3>
            Customer facility history rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.customerFacilityHistoryRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "customerFacilityHistoryRule-details",
                  customerFacilityHistoryRuleInfoOpen,
                  setCustomerFacilityHistoryRuleInfoOpen,
                )}
                title={
                  customerFacilityHistoryRuleInfoOpen
                    ? "Hide info"
                    : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {customerFacilityHistoryRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when a customer visits a
              merchant facility type for the first time. Sudden changes in
              preference (e.g., switching from full-service to automated
              stations) are flagged as higher risk based on the Facility rule
              settings.
            </p>
          </div>
        )}

        <CustomerFacilityHistoryRuleConfig
          customerHistoryConfig={data.riskEvaluation.customerHistoryRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.customerCountryHistoryRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="customerHistoryRule"
        id="customerHistoryRule-details"
      >
        <summary>
          <h3>
            Customer history rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.customerHistoryRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "customerHistoryRule-details",
                  customerHistoryRuleInfoOpen,
                  setCustomerHistoryRuleInfoOpen,
                )}
                title={customerHistoryRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {customerHistoryRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when a customer visits a
              monitored merchant (hotspot) for the first time within the
              configured history period. This detects unusual activity at
              high-risk locations defined by the Hotspot rule.
            </p>
          </div>
        )}

        <CustomerHistoryRuleConfig
          config={data.riskEvaluation.customerHistoryRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.customerHistoryRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="customerOriginRule"
        id="customerOriginRule-details"
      >
        <summary>
          <h3>
            Customer origin rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.customerOriginRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "customerOriginRule-details",
                  customerOriginRuleInfoOpen,
                  setCustomerOriginRuleInfoOpen,
                )}
                title={customerOriginRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {customerOriginRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>
                Adjusts the risk score based on the customer's estimated country
                of origin
              </strong>
              , derived from the card's language code. Certain origins correlate
              with different fraud probabilities, which can be configured in the
              rule table.
            </p>
          </div>
        )}

        <CustomerOriginRuleConfig
          config={data.riskEvaluation.customerOriginRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.customerOriginRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="daytimeRule"
        id="daytimeRule-details"
      >
        <summary>
          <h3>
            Daytime rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.daytimeRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "daytimeRule-details",
                  daytimeRuleInfoOpen,
                  setDaytimeRuleInfoOpen,
                )}
                title={daytimeRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {daytimeRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> for transactions
              occurring during high-risk periods, such as Friday evening through
              Sunday. Data analysis indicates fraud is more likely during these
              specific times, so the rule adds to the total risk.
            </p>
          </div>
        )}

        <DaytimeRuleConfig
          config={data.riskEvaluation.daytimeRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.daytimeRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="facilityRule"
        id="facilityRule-details"
      >
        <summary>
          <h3>
            Facility rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.facilityRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "facilityRule-details",
                  facilityRuleInfoOpen,
                  setFacilityRuleInfoOpen,
                )}
                title={facilityRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {facilityRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>
                Adjusts the risk score based on the merchant's facility codes
              </strong>
              , as fraudsters often target specific types of locations. This
              rule allows you to configure risk levels for different facility
              classes in the settings.
            </p>
          </div>
        )}

        <FacilityRuleConfig
          config={data.riskEvaluation.facilityRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.facilityRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="fuelGuardAutoAllowRule"
        id="fuelGuardAutoAllowRule-details"
      >
        <summary>
          <h3>
            Fuel guard auto allow rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.fuelGuardAutoAllowRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "fuelGuardAutoAllowRule-details",
                  fuelGuardAutoAllowRuleInfoOpen,
                  setFuelGuardAutoAllowRuleInfoOpen,
                )}
                title={
                  fuelGuardAutoAllowRuleInfoOpen ? "Hide info" : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {fuelGuardAutoAllowRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Reduces the risk score</strong> for transactions involving
              cards equipped with Fuel Guard. Similar to the Card Lock rule, the
              presence of this active security feature lowers the probability of
              fraud.
            </p>
          </div>
        )}

        <FuelGuardAutoAllowRuleConfig
          config={data.riskEvaluation.fuelGuardAutoAllowRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.fuelGuardAutoAllowRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="hotspotQuotientRule"
        id="hotspotQuotientRule-details"
      >
        <summary>
          <h3>
            Hotspot quotient rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.hotspotQuotientRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "hotspotQuotientRule-details",
                  hotspotQuotientRuleInfoOpen,
                  setHotspotQuotientRuleInfoOpen,
                )}
                title={hotspotQuotientRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {hotspotQuotientRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>
                Dynamically adjusts the risk score based on the merchant's
                historical fraud rate.
              </strong>{" "}
              Unlike the standard Hotspot rule, this scales the risk: if a
              merchant's fraud percentage reaches a defined threshold (e.g.,
              3%), the rule applies the maximum risk score.
            </p>
          </div>
        )}

        <HotspotQuotientRuleConfig />
      </details>

      <details
        className="config-section"
        data-section-id="hotspotRule"
        id="hotspotRule-details"
      >
        <summary>
          <h3>
            Hotspot rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.hotspotRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "hotspotRule-details",
                  hotspotRuleInfoOpen,
                  setHotspotRuleInfoOpen,
                )}
                title={hotspotRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {hotspotRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> for transactions at
              merchants classified as "Hotspots." Fraudsters often target
              specific locations, so this rule applies higher risk based on the
              merchant's classification.
            </p>
          </div>
        )}

        <HotspotRuleConfig
          config={data.riskEvaluation.hotspotRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.hotspotRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="odometerHistoryRule"
        id="odometerHistoryRule-details"
      >
        <summary>
          <h3>
            Odometer history rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.odometerHistoryRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "odometerHistoryRule-details",
                  odometerHistoryRuleInfoOpen,
                  setOdometerHistoryRuleInfoOpen,
                )}
                title={odometerHistoryRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {odometerHistoryRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> if the current odometer
              reading deviates from the customer's history. It checks if the
              value has been used before or follows a logical incremental
              pattern. If neither condition is met—suggesting a fraudster
              guessing the input—the risk is raised.
            </p>
          </div>
        )}

        <OdometerHistoryRuleConfig
          config={data.riskEvaluation.odometerHistoryRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.odometerHistoryRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="odometerIncrementHistoryRule"
        id="odometerIncrementHistoryRule-details"
      >
        <summary>
          <h3>
            Odometer increment history rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.odometerIncrementHistoryRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "odometerIncrementHistoryRule-details",
                  odometerIncrementHistoryRuleInfoOpen,
                  setOdometerIncrementHistoryRuleInfoOpen,
                )}
                title={
                  odometerIncrementHistoryRuleInfoOpen
                    ? "Hide info"
                    : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {odometerIncrementHistoryRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Reduces the risk score</strong> when the odometer reading
              follows a logical, incremental pattern based on the card's
              history. Since fraudsters rarely guess sequential values
              correctly, a consistent growing series strongly indicates a
              legitimate transaction.
            </p>
          </div>
        )}

        <OdometerIncrementHistoryRuleConfig
          config={data.riskEvaluation.odometerIncrementHistoryRuleConfig}
          odometerHistoryRuleConfig={
            data.riskEvaluation.odometerHistoryRuleConfig
          }
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.odometerIncrementHistoryRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="odometerOutwornIncrementRule"
        id="odometerOutwornIncrementRule-details"
      >
        <summary>
          <h3>
            Odometer outworn increment rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.odometerOutwornIncrementRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "odometerOutwornIncrementRule-details",
                  odometerOutwornIncrementRuleInfoOpen,
                  setOdometerOutwornIncrementRuleInfoOpen,
                )}
                title={
                  odometerOutwornIncrementRuleInfoOpen
                    ? "Hide info"
                    : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {odometerOutwornIncrementRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when a significantly
              older odometer value is reused after newer, higher readings have
              already been recorded. This suggests a fraudster is using "stale"
              data skimmed from a card in the past. To avoid false positives,
              reusing the <em>most recent</em> value within 48 hours is
              permitted, but reusing it after that window triggers a high risk
              score.
            </p>
          </div>
        )}

        <OdometerOutwornIncrementRuleConfig
          config={data.riskEvaluation.odometerOutwornIncrementRuleConfig}
          odometerHistoryRuleConfig={
            data.riskEvaluation.odometerHistoryRuleConfig
          }
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.odometerOutwornIncrementRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="odometerLengthHistoryRule"
        id="odometerLengthHistoryRule-details"
      >
        <summary>
          <h3>
            Odometer length history rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.odometerLengthHistoryRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "odometerLengthHistoryRule-details",
                  odometerLengthHistoryRuleInfoOpen,
                  setOdometerLengthHistoryRuleInfoOpen,
                )}
                title={
                  odometerLengthHistoryRuleInfoOpen ? "Hide info" : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {odometerLengthHistoryRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when the length of the
              odometer input (number of digits) deviates from the customer's
              history. Fraudsters often input longer values than legitimate
              users, so a previously unused length raises the risk.
            </p>
          </div>
        )}

        <OdometerLengthHistoryRuleConfig
          config={data.riskEvaluation.odometerLengthHistoryRuleConfig}
          odometerHistoryRuleConfig={
            data.riskEvaluation.odometerHistoryRuleConfig
          }
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.odometerLengthHistoryRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="odometerRule"
        id="odometerRule-details"
      >
        <summary>
          <h3>
            Odometer rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.odometerRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "odometerRule-details",
                  odometerRuleInfoOpen,
                  setOdometerRuleInfoOpen,
                )}
                title={odometerRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {odometerRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>
                Increases the risk score for suspicious odometer inputs.
              </strong>{" "}
              Fraudsters often repeat specific values (e.g., 12345). This rule
              identifies these high-risk inputs as "Hot" or "Warm" based on
              historical data and applies a higher risk score.
            </p>
          </div>
        )}

        <OdometerRuleConfig
          config={data.riskEvaluation.odometerRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.odometerRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="recentHotspotRule"
        id="recentHotspotRule-details"
      >
        <summary>
          <h3>
            Recent hotspot rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.recentHotspotRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "recentHotspotRule-details",
                  recentHotspotRuleInfoOpen,
                  setRecentHotspotRuleInfoOpen,
                )}
                title={recentHotspotRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {recentHotspotRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> specifically for
              transactions at merchants marked as "Recent hotspots" or "Recent
              semi-hotspots." While similar to the standard Hotspot rule, this
              targets locations that have been recently flagged for fraud
              activity.
            </p>
          </div>
        )}

        <RecentHotspotRuleConfig
          config={data.riskEvaluation.recentHotspotRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.recentHotspotRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="immediateHotspotRule"
        id="immediateHotspotRule-details"
      >
        <summary>
          <h3>
            Immediate hotspot rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.recentHotspotRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "immediateHotspotRule-details",
                  immediateHotspotRuleInfoOpen,
                  setImmediateHotspotRuleInfoOpen,
                )}
                title={immediateHotspotRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {immediateHotspotRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when a transaction occurs at a location where vulnerable PANs (cards with failed hotspot transactions) were recently used. The merchant gains "Immediate Hotspot" status for 30 minutes with 25% higher risk score than Recent Hotspot, enabling real-time fraud detection.
            </p>
          </div>
        )}

        <ImmediateHotspotRuleConfig
          config={data.riskEvaluation.immediateHotspotRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.immediateHotspotRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="rejectHistoryRule"
        id="rejectHistoryRule-details"
      >
        <summary>
          <h3>
            Reject history rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.rejectHistoryRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "rejectHistoryRule-details",
                  rejectHistoryRuleInfoOpen,
                  setRejectHistoryRuleInfoOpen,
                )}
                title={rejectHistoryRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {rejectHistoryRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> if the card has had
              transactions declined by the system within a specific recent
              interval. A history of rejections often indicates higher risk or
              potential misuse.
            </p>
          </div>
        )}

        <RejectHistoryRuleConfig
          config={data.riskEvaluation.rejectHistoryRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.rejectHistoryRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="similarOdometerRule"
        id="similarOdometerRule-details"
      >
        <summary>
          <h3>
            Similar odometer rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.similarOdometerRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "similarOdometerRule-details",
                  similarOdometerRuleInfoOpen,
                  setSimilarOdometerRuleInfoOpen,
                )}
                title={similarOdometerRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {similarOdometerRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when multiple cards use
              identical or highly similar odometer values at the same merchant
              within a short time. It is highly unlikely for different customers
              to enter the same specific values (e.g., 111111), suggesting a
              single fraudster using multiple cards.
            </p>
          </div>
        )}

        <SimilarOdometerRuleConfig
          config={data.riskEvaluation.similarOdometerRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.similarOdometerRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="suddenHotspotRejectRule"
        id="suddenHotspotRejectRule-details"
      >
        <summary>
          <h3>
            Sudden hotspot reject rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.suddenHotspotRejectRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "suddenHotspotRejectRule-details",
                  suddenHotspotRejectRuleInfoOpen,
                  setSuddenHotspotRejectRuleInfoOpen,
                )}
                title={
                  suddenHotspotRejectRuleInfoOpen ? "Hide info" : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {suddenHotspotRejectRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> if the current
              transaction is at a hotspot and the card has a recent rejection
              (e.g., wrong PIN) at a hotspot. This detects fraudsters repeatedly
              attempting transactions at high-risk locations.
            </p>
          </div>
        )}

        <SuddenHotspotRejectRuleConfig
          config={data.riskEvaluation.suddenHotspotRejectRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.suddenHotspotRejectRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="suddenHotspotVisitRule"
        id="suddenHotspotVisitRule-details"
      >
        <summary>
          <h3>
            Sudden hotspot visit rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.suddenHotspotVisitRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "suddenHotspotVisitRule-details",
                  suddenHotspotVisitRuleInfoOpen,
                  setSuddenHotspotVisitRuleInfoOpen,
                )}
                title={
                  suddenHotspotVisitRuleInfoOpen ? "Hide info" : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {suddenHotspotVisitRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when a dormant card
              suddenly transacts at a hotspot it has never visited before. A
              period of inactivity followed by a new visit to a high-risk
              location is a strong fraud indicator.
            </p>
          </div>
        )}

        <SuddenHotspotVisitRuleConfig
          config={data.riskEvaluation.suddenHotspotVisitRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.suddenHotspotVisitRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="suspiciousPassageRule"
        id="suspiciousPassageRule-details"
      >
        <summary>
          <h3>
            Suspicious passage rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.suspiciousPassageRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "suspiciousPassageRule-details",
                  suspiciousPassageRuleInfoOpen,
                  setSuspiciousPassageRuleInfoOpen,
                )}
                title={
                  suspiciousPassageRuleInfoOpen ? "Hide info" : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {suspiciousPassageRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when a customer visits a
              hotspot or monitored facility for the first time. The score scales
              based on the customer's total history of hotspot visits, as
              frequent past exposure increases the likelihood the card was
              previously compromised.
            </p>
          </div>
        )}

        <SuspiciousPassageRuleConfig
          config={data.riskEvaluation.suspiciousPassageRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.suspiciousPassageRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="trialTransactionRule"
        id="trialTransactionRule-details"
      >
        <summary>
          <h3>
            Trial transaction rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.trialTransactionRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "trialTransactionRule-details",
                  trialTransactionRuleInfoOpen,
                  setTrialTransactionRuleInfoOpen,
                )}
                title={trialTransactionRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {trialTransactionRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> if the card has a
              history of "trial" transactions—pre-authorizations ("A") without
              subsequent purchases ("P"). This pattern suggests a fraudster
              testing if the card is active without making a purchase.
            </p>
          </div>
        )}

        <TrialTransactionRuleConfig
          config={data.riskEvaluation.trialTransactionRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.trialTransactionRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="varyingOdometerRule"
        id="varyingOdometerRule-details"
      >
        <summary>
          <h3>
            Varying odometer rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.varyingOdometerRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "varyingOdometerRule-details",
                  varyingOdometerRuleInfoOpen,
                  setVaryingOdometerRuleInfoOpen,
                )}
                title={varyingOdometerRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {varyingOdometerRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when different odometer
              values are entered for the same card within a short period (e.g.,
              30 minutes). This inconsistency often indicates a fraudster
              guessing random numbers on retries rather than reporting a real
              reading.
            </p>
          </div>
        )}

        <VaryingOdometerRuleConfig
          config={data.riskEvaluation.varyingOdometerRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.varyingOdometerRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="velocityRule"
        id="velocityRule-details"
      >
        <summary>
          <h3>
            Velocity rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.velocityRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "velocityRule-details",
                  velocityRuleInfoOpen,
                  setVelocityRuleInfoOpen,
                )}
                title={velocityRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {velocityRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when the travel speed
              between consecutive transactions is physically impossible or
              suspicious. It calculates "Gross" velocity (raw speed) and "Neat"
              velocity (adjusted for mandatory breaks). Gross speeds &gt;140km/h
              trigger high risk, while "Neat" velocity applies a moderated score
              to account for legitimate scenarios like double-manning.
            </p>
          </div>
        )}

        <VelocityRuleConfig
          config={data.riskEvaluation.velocityRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.velocityRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="volumeHistoryRule"
        id="volumeHistoryRule-details"
      >
        <summary>
          <h3>
            Volume history rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.volumeHistoryRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "volumeHistoryRule-details",
                  volumeHistoryRuleInfoOpen,
                  setVolumeHistoryRuleInfoOpen,
                )}
                title={volumeHistoryRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {volumeHistoryRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when recent refueling
              volumes significantly exceed the customer's historical average.
              The rule calculates a statistical baseline (mean and standard
              deviation) for the card and segments recent activity into risk
              levels based on how far it deviates from this norm.
            </p>
          </div>
        )}

        <VolumeHistoryRuleConfig
          config={data.riskEvaluation.volumeHistoryRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.volumeHistoryRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="volumeRule"
        id="volumeRule-details"
      >
        <summary>
          <h3>
            Volume rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.volumeRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "volumeRule-details",
                  volumeRuleInfoOpen,
                  setVolumeRuleInfoOpen,
                )}
                title={volumeRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {volumeRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> when the cumulative
              refueling volume at a single merchant exceeds country-specific
              thresholds within a set time window. High volumes trigger
              "Suspicious" or "Very suspicious" scores. Notably, this rule
              aggregates volume across <em>all</em> transactions at that
              merchant during the window (e.g., 20 minutes), meaning a high
              total volume affects the risk score for every card used there.
            </p>
          </div>
        )}

        <VolumeRuleConfig
          config={data.riskEvaluation.volumeRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.volumeRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="anyAuthRejectRule"
        id="anyAuthRejectRule-details"
      >
        <summary>
          <h3>
            Any auth reject rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.anyAuthRejectRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "anyAuthRejectRule-details",
                  authRejectRulesInfoOpen,
                  setAuthRejectRulesInfoOpen,
                )}
                title={authRejectRulesInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {authRejectRulesInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> based on the frequency
              of recent failed authorizations at a merchant. It monitors
              specific rejection codes (e.g., Incorrect PIN, Card Locked) to
              detect suspicious spikes in failures. The rule is configurable to
              count every failure, group them by unique card, or ignore failures
              if a successful transaction immediately follows (indicating a
              legitimate user correcting a mistake).
            </p>
          </div>
        )}

        <AuthRejectConfig
          config={data.riskEvaluation.anyAuthRejectRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.anyAuthRejectRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="cardDeckAuthRejectRule"
        id="cardDeckAuthRejectRule-details"
      >
        <summary>
          <h3>
            Card deck auth reject rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.cardDeckAuthRejectRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "cardDeckAuthRejectRule-details",
                  authRejectRulesInfoOpen,
                  setAuthRejectRulesInfoOpen,
                )}
                title={authRejectRulesInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {authRejectRulesInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> based on the frequency
              of recent failed authorizations at a merchant. It monitors
              specific rejection codes (e.g., Incorrect PIN, Card Locked) to
              detect suspicious spikes in failures. The rule is configurable to
              count every failure, group them by unique card, or ignore failures
              if a successful transaction immediately follows (indicating a
              legitimate user correcting a mistake).
            </p>
          </div>
        )}

        <AuthRejectConfig
          config={data.riskEvaluation.cardDeckAuthRejectRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.cardDeckAuthRejectRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="cardLockAuthRejectRule"
        id="cardLockAuthRejectRule-details"
      >
        <summary>
          <h3>
            Card lock auth reject rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.cardLockAuthRejectRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "cardLockAuthRejectRule-details",
                  authRejectRulesInfoOpen,
                  setAuthRejectRulesInfoOpen,
                )}
                title={authRejectRulesInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {authRejectRulesInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> based on the frequency
              of recent failed authorizations at a merchant. It monitors
              specific rejection codes (e.g., Incorrect PIN, Card Locked) to
              detect suspicious spikes in failures. The rule is configurable to
              count every failure, group them by unique card, or ignore failures
              if a successful transaction immediately follows (indicating a
              legitimate user correcting a mistake).
            </p>
          </div>
        )}

        <AuthRejectConfig
          config={data.riskEvaluation.cardLockAuthRejectRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.cardLockAuthRejectRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="fraudAuthRejectRule"
        id="fraudAuthRejectRule-details"
      >
        <summary>
          <h3>
            Fraud auth reject rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.fraudAuthRejectRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "fraudAuthRejectRule-details",
                  authRejectRulesInfoOpen,
                  setAuthRejectRulesInfoOpen,
                )}
                title={authRejectRulesInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {authRejectRulesInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> based on the frequency
              of recent failed authorizations at a merchant. It monitors
              specific rejection codes (e.g., Incorrect PIN, Card Locked) to
              detect suspicious spikes in failures. The rule is configurable to
              count every failure, group them by unique card, or ignore failures
              if a successful transaction immediately follows (indicating a
              legitimate user correcting a mistake).
            </p>
          </div>
        )}

        <AuthRejectConfig
          config={data.riskEvaluation.fraudSuspicionAuthRejectRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.fraudSuspicionAuthRejectRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="fuelGuardAuthRejectRule"
        id="fuelGuardAuthRejectRule-details"
      >
        <summary>
          <h3>
            Fuel guard auth reject rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.fuelGuardAuthRejectRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "fuelGuardAuthRejectRule-details",
                  authRejectRulesInfoOpen,
                  setAuthRejectRulesInfoOpen,
                )}
                title={authRejectRulesInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {authRejectRulesInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> based on the frequency
              of recent failed authorizations at a merchant. It monitors
              specific rejection codes (e.g., Incorrect PIN, Card Locked) to
              detect suspicious spikes in failures. The rule is configurable to
              count every failure, group them by unique card, or ignore failures
              if a successful transaction immediately follows (indicating a
              legitimate user correcting a mistake).
            </p>
          </div>
        )}

        <AuthRejectConfig
          config={data.riskEvaluation.fuelGuardAuthRejectRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.fuelGuardAuthRejectRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="pabloAuthRejectRule"
        id="pabloAuthRejectRule-details"
      >
        <summary>
          <h3>
            Pablo auth reject rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.pabloAuthRejectRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "pabloAuthRejectRule-details",
                  authRejectRulesInfoOpen,
                  setAuthRejectRulesInfoOpen,
                )}
                title={authRejectRulesInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {authRejectRulesInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> based on the frequency
              of recent failed authorizations at a merchant. It monitors
              specific rejection codes (e.g., Incorrect PIN, Card Locked) to
              detect suspicious spikes in failures. The rule is configurable to
              count every failure, group them by unique card, or ignore failures
              if a successful transaction immediately follows (indicating a
              legitimate user correcting a mistake).
            </p>
          </div>
        )}

        <AuthRejectConfig
          config={data.riskEvaluation.pabloAuthRejectRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.pabloAuthRejectRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="insufficientPinEffortRule"
        id="insufficientPinEffortRule-details"
      >
        <summary>
          <h3>
            Insufficient PIN effort rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.insufficientPinEffortRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "insufficientPinEffortRule-details",
                  insufficientPinEffortRuleInfoOpen,
                  setInsufficientPinEffortRuleInfoOpen,
                )}
                title={
                  insufficientPinEffortRuleInfoOpen ? "Hide info" : "Show info"
                }
              />
            </span>
          </h3>
        </summary>

        {insufficientPinEffortRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Increases the risk score</strong> for incorrect PIN
              attempts that aren't followed by a successful retry. Unlike
              legitimate users who usually keep trying, fraudsters often abandon
              a card after 1 or 2 failed guesses. Therefore, fewer consecutive
              failures result in a <em>higher</em> risk score, while a
              subsequent success negates the risk.
            </p>
          </div>
        )}

        <InsufficientPinEffortRuleConfig
          config={data.riskEvaluation.insufficientPinEffortRuleConfig}
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.insufficientPinEffortRuleConfig = e;
            })
          }
        />
      </details>

      <details
        className="config-section"
        data-section-id="customerHistoryPatternRule"
        id="customerHistoryPatternRule-details"
      >
        <summary>
          <h3>
            Customer history pattern rule{" "}
            <span className="section-header-icons">
              <Note
                noteTargetPath="rulesConfig.customerHistoryPatternyRule"
                noteTargetId={data.id}
              />
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="info-icon"
                onClick={handleInfoIconClick(
                  "customerHistoryPatternRule-details",
                  customerHistoryPatternRuleInfoOpen,
                  setCustomerHistoryPatternRuleInfoOpen,
                )}
                title={customerHistoryPatternRuleInfoOpen ? "Hide info" : "Show info"}
              />
            </span>
          </h3>
        </summary>

        {customerHistoryPatternRuleInfoOpen && (
          <div className="info-box">
            <p>
              <strong>Reduces the risk score</strong> when a transaction matches a customer's established behavioral patterns. The rule identifies patterns over a 6-month period, classifying them into tiers based on quality. A pattern's quality is tracked monthly; higher tiers and higher relevance result in a stronger negative score (lower risk).
            </p>
          </div>
        )}

        <CustomerHistoryPatternRuleConfig
          config={data.riskEvaluation.customerHistoryPatternRuleConfig}
          generalConfig={
            generalConfig.generalConfig.customerHistoryPatternUpdateConfig
          }
          onChange={(e) =>
            updateData((d) => {
              d.riskEvaluation.customerHistoryPatternRuleConfig = e;
            })
          }
        />
      </details>
    </div>
  );
};

export default Component;
